export const getKey = (object, path, defaultValue) => {
    if (!object || !path) return defaultValue;

    const pathArray = path.replace(/\[/g, '.').replace(/\]/g, '.').split('.').filter(k => k);
    let index = 1;
    let ret = object[`${pathArray[0]}`];
    while (index < pathArray.length && ret !== null && ret !== undefined) {
        ret = ret[`${pathArray[index]}`];
        index++;
    }
    const isDepthReached = index === pathArray.length;
    if (isDepthReached) {
        return ret === undefined ? defaultValue : ret;
    }
    return defaultValue;
};

export default getKey;